import {DataStatus, FormSubmitHandler, showNotification} from 'platform/components';
import {Show} from 'platform/foundation';

import {isNotNil} from 'ramda-adjunct';

import {
  useGetMercedesNaSkladeRestPlatformQuery,
  useMercedesNaSkladeRestAuthenticateMutation,
} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  MercedesNaSkladeAuthenticationFormData,
  PlatformAuthenticationFormMercedesNaSklade,
} from './components/PlatformAuthenticationFormMercedesNaSklade';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';

export function PlatformSettingsMercedesNaSkladeRest() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isLoading, isError} = useGetMercedesNaSkladeRestPlatformQuery({params});
  const [saveAuthentication] = useMercedesNaSkladeRestAuthenticateMutation();

  const onSubmitCredentials: FormSubmitHandler<MercedesNaSkladeAuthenticationFormData> = (values) =>
    saveAuthentication({
      body: values,
      params,
    })
      .unwrap()
      .then(() => showNotification.success())
      .catch(handleApiError);

  return (
    <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_GENERAL_SETTINGS}>
      <DataStatus isLoading={isLoading} isError={isError}>
        {isNotNil(data) && (
          <PlatformAuthenticationFormMercedesNaSklade
            platformCode={AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE_REST}
            defaultValues={data.credentials}
            onSubmit={onSubmitCredentials}
          />
        )}
        <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.MERCEDES_NA_SKLADE_REST} />
      </DataStatus>
    </Show>
  );
}
